// If exam is Nail Technician Theory (Vietnamese) or Cosmetology Theory (Spanish), we don't show AiLA
export const EXCLUDED_EXAM_IDS = ["", ""];
